import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot } from "@angular/router";
import { AccueilComponent } from "app/+accueil/accueil.component";
import { Observable } from "rxjs";

export interface ActivatedAccount {
    isActivatedAccount(): boolean | Observable<boolean>;
}

@Injectable(
    // { providedIn: 'root' }
) 
export class IsActivatedAccountGuard implements CanDeactivate<AccueilComponent> { 
    canDeactivate(component: AccueilComponent, currentRoute: ActivatedRouteSnapshot, currentState: RouterStateSnapshot, nextState?: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean { 
        let connectedUser = !!JSON.parse(localStorage.getItem('enseigne'))  ? JSON.parse(localStorage.getItem('enseigne')) : '' 
    return (connectedUser && connectedUser.Statut);
    
} 
    }